/**
 * Executes an array of tasks in parallel, with optional batching (otherwise defaults to 5) and cancellation support.
 * @param tasks An array of functions that return promises.
 * @param options Options for controlling the execution.
 * @returns An array of results from the tasks.
 */
export async function batchPromiseAll<T>(
  tasks: (() => Promise<T>)[],
  options: { batchSize?: number; signal?: AbortSignal },
): Promise<T[]> {
  const results: T[] = [];
  let i = 0;

  const batchSize = options.batchSize ?? 5;
  while (i < tasks.length) {
    if (options.signal?.aborted) {
      throw new DOMException('Aborted', 'AbortError');
    }
    const batch = tasks.slice(i, i + batchSize).map(fn => fn());
    results.push(...(await Promise.all(batch)));
    i += batchSize;
  }
  return results;
}
